import Link from "next/link"
import React from "react"
import { withI18n } from "~/hocs"
import {
  Breadcrumb,
  Button,
  Col,
  Container,
  Row,
  Spinner,
  Modal,
  Form,
} from "react-bootstrap"
import { routes } from "~/router"
import ReCAPTCHA from "react-google-recaptcha"

const ViolationReport = ({
  t,
  formik,
  video,
  show,
  setShow,
  handleClose,
  showSuccessViolation,
  isLoading
}) => {
  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>不適切な写真として通報する</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {!showSuccessViolation && (
          <Form
            noValidate
            onSubmit={formik.handleSubmit}
            autoComplete="off"
            id="violationForm"
          >
            <div>
              <p>
                公序良俗に反する素材、著作権、肖像権などの権利を侵害している素材を発
                見された際は、お知らせください。確認後、必要がある場合は速やかに対応
                致します。
                通報くださった方へ、対応結果をお知らせすることは致しかねま
                すので、予めご了承くださいますようお願い申し上げます。
              </p>
              <Row>
                <Col xs={12} md={4}>
                  <span>写真タイトル：</span>
                </Col>
                <Col xs={6} md={8}>
                  {video.title}
                </Col>
              </Row>

              <Row>
                <Col xs={12} md={4}>
                  <span>• </span>
                  メールアドレス：
                </Col>
                <Col xs={6} md={8}>
                  <Form.Group className="mb-1" controlId="formBasicEmail">
                    <Form.Control
                      type="email"
                      name="email"
                      value={formik.values?.email}
                      onChange={formik.handleChange}
                    />
                  </Form.Group>
                  {formik.errors.email && formik.touched.email && (
                    <span className="ml-1 text-danger">
                      {formik.errors.email}
                    </span>
                  )}
                </Col>
              </Row>
              <Row>
                <Col xs={12} md={4}>
                  <span>• </span>
                  通報理由：
                </Col>
                <Col xs={6} md={8}>
                  <Form.Group
                    className="mb-1"
                    controlId="exampleForm.ControlTextarea1"
                  >
                    <Form.Control
                      as="textarea"
                      name="detail"
                      rows={3}
                      value={formik.values?.detail}
                      onChange={formik.handleChange}
                    />
                  </Form.Group>
                  {formik.errors.detail && formik.touched.detail && (
                    <span className="ml-1 text-danger">
                      {formik.errors.detail}
                    </span>
                  )}
                </Col>
              </Row>
              <p>
                <span>• </span>
                が付いている項目は必須入力です
              </p>
              <ReCAPTCHA
                sitekey={process.env.RECAPTCHA_KEY}
                onChange={(value) => {
                  formik.setValues({
                    ...formik.values,
                    capcha: value,
                  })
                }}
              />
              {formik.errors.capcha && formik.touched.capcha && (
                <span className="ml-1 text-danger">{formik.errors.capcha}</span>
              )}
              <Row>
                <Col xs={12} md={12} className="text-center mt-2">
                  <Button variant="primary" type="submit" disabled={isLoading}>
                    {isLoading && (
                      <Spinner
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                      />
                    )}
                    送信
                  </Button>
                </Col>
              </Row>
            </div>
          </Form>
        )}
        {showSuccessViolation && "通報しました。ご協力ありがとうございました。"}
      </Modal.Body>
    </Modal>
  )
}

export default withI18n(ViolationReport)
